import NotebookRecord from "models/view-models/notebook-record";
import { CollectionUtils } from "utilities/collection-utils";
import { ToastManager } from "utilities/toast/toast-manager";
import { t } from "utilities/localization-utils";
import { useDeleteNotebook } from "utilities/hooks/domain/notebooks/pages/use-delete-notebook";
import { useEffect, useState } from "react";

const useNotebookActions = (notebook: NotebookRecord | null | undefined) => {
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);

    const handleDeleteSuccess = () => {
        ToastManager.success(
            t("notebook-success-deleteNotebook", {
                notebookName: notebook?.name,
            })
        );

        setShowDeleteConfirmModal(false);
    };

    const { deleteNotebook, errors: deleteErrors } = useDeleteNotebook({
        notebook: notebook ?? undefined,
        onSuccess: handleDeleteSuccess,
    });

    useEffect(() => {
        if (!CollectionUtils.hasValues(deleteErrors)) {
            return;
        }

        ToastManager.error(
            t("notebook-error-deleteNotebook", { notebookName: notebook?.name })
        );
    }, [deleteErrors, notebook?.name]);

    return {
        setShowDeleteConfirmModal,
        showDeleteConfirmModal,
        setShowShareModal,
        showShareModal,
        deleteNotebook,
    };
};

export default useNotebookActions;
